import axios from 'axios';
import {apiBaseUrl} from './env';

const instance = axios.create ({
  headers: {
    'X-AUTH-TOKEN': window.localStorage.getItem ('ei_token'),
  },
});

console.log (apiBaseUrl);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch (url, params = {}) {
  return new Promise ((resolve, reject) => {
    axios
      .get (apiBaseUrl + url, {
        params,
        headers: {
          'X-AUTH-TOKEN': window.localStorage.getItem ('ei_token'),
        },
      })
      .then (response => {
        const httpStatus = response.status.toString ();
        if (/2[\d]{2}/.test (httpStatus)) {
          if (response.data.Success === true) {
            resolve (response.data.Result);
          } else {
            if (response.data.UnAuthorizedRequest) {
              // redirect to wechat login
              redirectToWechatLogin ();
            } else {
              reject (response.data);
            }
          }
        } else if (/3[\d]{2}/.test (httpStatus)) {
        } else if (/4[\d]{2}/.test (httpStatus)) {
        } else if (/5[\d]{2}/.test (httpStatus)) {
          this.$dialog.toast ({
            mes: response.data.ErrorMessage,
            timeout: 2500,
          });
        }
      })
      .catch (err => {
        console.warn ('network error=>' + err);
      });
  });
}

export function getRequestId () {
  return fetch ('/api/common/GetRequestNumber');
}

function redirectToWechatLogin () {
  const path = window.location.pathname + window.location.search;
  const host = `${window.location.protocol}//${window.location.host}`;
  window.location.href = `https://passport.gongyila.com/Weixin/Authorize/Auth?ReturnUrl=${host}/wxcallback/?ReturnUrl=${host}${window.encodeURIComponent (path)}`;
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data) {
  return new Promise ((resolve, reject) => {
    instance
      .post (apiBaseUrl + url, data)
      .then (response => {
        const httpStatus = response.status.toString ();
        if (/2[\d]{2}/.test (httpStatus)) {
          if (response.data.Success === true) {
            resolve (response.data.Result);
          } else {
            if (response.data.UnAuthorizedRequest) {
              // redirect to wechat login
              redirectToWechatLogin ();
            } else {
              reject (response.data);
            }
          }
        } else if (/3[\d]{2}/.test (httpStatus)) {
        } else if (/4[\d]{2}/.test (httpStatus)) {
        } else if (/5[\d]{2}/.test (httpStatus)) {
          this.$dialog.toast ({
            mes: response.data.ErrorMessage,
            timeout: 2500,
          });
        }
      })
      .catch (err => {
        this.$dialog.toast ({
          mes: '网络请求失败',
          timeout: 2500,
        });
      });
  });
}
export function postImg (url, data) {
  var config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return new Promise ((resolve, reject) => {
    axios
      .post (apiBaseUrl + url, data, config)
      .then (response => {
        resolve (response.data.Result);
      })
      .catch (err => {
        reject (err);
      });
  });
}

export function postUrl (url, data = {}) {
  if (url.indexOf ('?' === -1)) {
    url += '?';
  }
  for (var index in data) {
    url += index + '=' + data[index] + '&';
  }
  // var qs = require("queryString");
  return new Promise ((resolve, reject) => {
    axios
      .post (apiBaseUrl + url)
      .then (response => {
        var httpStatus = response.status.toString ();
        if (/2[\d]{2}/.test (httpStatus)) {
          // 200+
          if (response.data.Success === true) {
            resolve (response.data.Result);
          } else {
            // this.$message.error (response.data.Error.Message);
            reject (response.data);
          }
        } else if (/3[\d]{2}/.test (httpStatus)) {
          //
        } else if (/4[\d]{2}/.test (httpStatus)) {
        } else if (/5[\d]{2}/.test (httpStatus)) {
        }
      })
      .catch (err => {
        reject (err);
      });
  });
}
